import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class VersionSelector extends Component {
  static propTypes = {
    handleOnChange: PropTypes.func.isRequired,
    selectedVersion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    versions: PropTypes.array,
  };

  static defaultProps = {
    selectedVersion: undefined,
    versions: null,
  };

  shouldComponentUpdate = nextProps => {
    const { versions, selectedVersion } = this.props;
    if (nextProps.versions !== versions) {
      return true;
    }
    if (nextProps.selectedVersion !== selectedVersion) {
      return true;
    }
    return false;
  };

  handleVersionChange = e => {
    const { handleOnChange } = this.props;
    handleOnChange(e);
  };

  renderVersion = version => {
    const createdOn = new Date(version.createdOn);
    const formattedDate = createdOn.toUTCString();

    // Currently, versions have no "title" attribute
    return (
      <option key={version.version} value={version.version}>
        {version.status === 1 ? 'Current ' : ''}
        Version (#{version.version}) ( {formattedDate} )
      </option>
    );
  };

  render() {
    const { selectedVersion, versions } = this.props;

    return versions && versions.length !== 0 ? (
      <select
        className="form-control field-inline"
        id="version"
        value={
          versions !== undefined && versions.length !== 0 && selectedVersion === undefined
            ? versions.filter(v => v.status === 1)[0].id
            : selectedVersion
        }
        onChange={this.handleVersionChange}
      >
        {versions.map(this.renderVersion)}
      </select>
    ) : (
      <select className="form-control field-inline" id="version">
        <option>There currently is no live version </option>
      </select>
    );
  }
}
